import { QuickAddProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import { QuickAddBase } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/components/QuickAdd/QuickAddBase";
import { Core } from "@faire/design-tokens";
import { Add } from "@faire/slate/icons/Add";
import { NoSSR } from "@faire/web/common/NoSSR";
import { SVGIcon } from "@faire/web/slate/icons/SVGIcon";
import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React from "react";

export const DeferRenderedQuickAdd = ({
  data,
  className,
}: {
  data: QuickAddProps & { showOnHover: boolean };
  className?: string;
}) => {
  return (
    <NoSSR serverRenderFallback={<QuickAddPlaceholder />}>
      <WhenVisibilityIsImminent>
        <QuickAddBase data={data} className={className} />
      </WhenVisibilityIsImminent>
    </NoSSR>
  );
};

const QuickAddPlaceholder = () => {
  return (
    <div className="absolute right-0 bottom-0 z-5 p-[8px]">
      <div className="border-core-border-muted bg-core-surface-inverse flex h-[32px] w-[32px] items-center justify-center rounded-full border p-1">
        <SVGIcon color={Core.surface.default}>
          <Add />
        </SVGIcon>
      </div>
    </div>
  );
};
